






























































import {Component, Vue} from "vue-property-decorator";
import BlocklyEditor from "../components/editor/index.vue";
import Game from "../components/game/index.vue";
import {ACTION_SELECT_LEVEL, MUTATION_SET_LEVEL} from "../store/CourseProgress";

interface LogEntry {
    line: string;
    type: string;
    color: string;
}

@Component({
    components: {BlocklyEditor, Game}
})
export default class Editor extends Vue {

    // state:
    public instructionCounter: number = 0;
    public debugLog: LogEntry[] = [];
    public showDebugLog: boolean = false;
    public gameOverReason: string = "";
    // synced:
    public blockCount: number = 0;
    public gameIsRunning: boolean = false;
    public gameIsPaused: boolean = false;

    mounted() {
        const vue = this;
        this.$store.subscribe((mutation) => {
            if (mutation.type === MUTATION_SET_LEVEL) {
                vue.instructionCounter = 0;
                vue.debugLog = [];
                vue.gameOverReason = "";
            }
        })
    }

    get level() {
        return this.$store.getters.currentLevel;
    }
    get renderDebugLog() {
        return this.level ? this.level.showDebugLog : false;
    }
    get maxBlocks() {
        return this.level ? this.level.maxBlocks : Infinity;
    }

    get fullLog() {
        const copy = this.debugLog.slice();
        if (this.level) {
            copy.unshift({
                type: this.$t("editor.debugLogTypes.levelDescription").toString(),
                line: this.level.description, color: "none"
            });
        }
        return copy;
    }

    get debugLogIcon() {
        return this.showDebugLog ? "angle-down" : "angle-up";
    }
    get logTableFields() {
        return [
            {key: "type", label: ""},
            {key: "line", label: ""}
        ];
    }

    get runButtonColor() {
        return this.gameIsRunning ? "warning" : "primary";
    }
    get runButtonText() {
        if (this.gameIsRunning) {
            if (this.gameIsPaused) {
                return this.$t("game.continueBtnLabel");
            } else {
                return this.$t("game.pauseBtnLabel");
            }
        } else {
            return this.$t("game.startBtnLabel");
        }
    }
    get runButtonIcon() {
        if (this.gameIsRunning) {
            if (this.gameIsPaused) {
                return "play";
            } else {
                return "pause";
            }
        } else {
            return "play";
        }
    }

    public runButtonClick() {
        if (this.gameIsRunning) {
            if (this.gameIsPaused) {
                (this.$refs.game as any).continueGame();
            } else {
                (this.$refs.game as any).pauseGame();
            }
        } else {
            const code = (this.$refs.editor as any).compile();
            console.log(`-------- ${new Date()}: Newly generated code ------\n`, code);
            (this.$refs.game as any).startGame(code);
        }
    }
    public stopButtonClick() {
        this.debugLog = [];
        this.gameOverReason = "";
        this.instructionCounter = 0;
        (this.$refs.game as any).stopAndResetGame();
    }

    // ----- GAME EVENTS -------
    public highlightBlock(blockId: string) {
        if (blockId !== null) {
            this.instructionCounter++;
        }
        (this.$refs.editor as any).highlightBlock(blockId);
    }
    public debugLogAppend(log: string, blockId: string) {
        this.debugLog.push({line: log, color: '#2e66cc', type: this.$t("editor.debugLogTypes.debugLog").toString()});
    }
    public onGameOver(victory: boolean, reason: string) {
        this.gameOverReason = reason;
        this.debugLog.push({
            line: reason, type: this.$t("editor.debugLogTypes.gameOver").toString(), color: victory ? "#54a928" : "#ff5f44"
        });
        if (victory) {
            (this.$refs.gameOverModal as any).show();
        }
    }
    public onNextLevel() {
        // TODO this could be easier... use vuex-router-sync?
        if (this.$store.getters.hasNextLevel) {
            const nextLevel = this.$store.state.CourseProgressModule.currentLevel + 1;
            this.$store.dispatch(ACTION_SELECT_LEVEL, nextLevel);
            this.$router.push(`/lessons/${this.$route.params["lessonId"]}/levels/${nextLevel}`);
        } else {
            this.$router.push('/lessons')
        }
    }

}
